// 给对象数组去重，指定key
export function uniqueObjectArray(originalArray, key) {
  const uniqueArray = [];
  const keySet = {};

  for (const item of originalArray) {
    if (!keySet[item[key]]) {
      uniqueArray.push(item);
      keySet[item[key]] = true;
    }
  }
  return uniqueArray;
}
// 十进制转换为二进制字符串数组
export function transformToBinaryList(bigNumStr, arrLength) {
  if (bigNumStr === undefined || bigNumStr === null) {
    bigNumStr = "0";
  }
  // 权限数字是int64的大数
  let num = BigInt(bigNumStr);
  const binaryStr = num.toString(2);
  const binaryArr = binaryStr
    .split("")
    .reverse()
    .map((item) => parseInt(item));
  for (let i = binaryArr.length; i < arrLength; i++) {
    binaryArr.push(0);
  }
  return binaryArr;
}

export function binaryListToBigIntNum(list) {
  const binaryStr = "0b" + list.reverse().join("");
  return BigInt(binaryStr).toString();
}

// 从对象数组中获取key===value的index
export function getIndexFromArrayByKeyValue(list, key, value) {
  let index = -1;
  for (let i = 0; i < list.length; i++) {
    if (list[i][key] == value) {
      index = i;
      break;
    }
  }
  return index;
}

// 根据数组里面最小最大值获取一个随机数
export function randomNumByArray(arr) {
  if (!arr || arr.length == 0) return "";
  if (arr.length === 1) return arr[1];
  let max = Math.max(...arr);
  let min = Math.min(...arr);
  let random = Math.random() * (max - min) + min;
  return Math.round(random);
}

// 比较数组是否相同
export function isSameArr(arr1, arr2){
  const arr1Str = JSON.stringify(arr1);
  const arr2Str = JSON.stringify(arr2);
  return arr1Str === arr2Str;
}